export default __webpack_public_path__ + "static/media/confirm.184c6b4a.svg";